import { render } from "./BasicMaterialSearch.vue?vue&type=template&id=1341da10&scoped=true"
import script from "./BasicMaterialSearch.vue?vue&type=script&lang=js"
export * from "./BasicMaterialSearch.vue?vue&type=script&lang=js"

import "./BasicMaterialSearch.vue?vue&type=style&index=0&id=1341da10&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1341da10"]])

export default __exports__